var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-to-top",class:{ hidden: _vm.isOnTop },attrs:{"title":"Back to top"},on:{"click":function($event){$event.preventDefault();return _vm.scrollTop()}}},[_c('i',{staticClass:"ion ion-chevron-up back-to-top-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }